var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8503 9.1018C17.9995 9.03599 18.1261 8.92786 18.2144 8.7908C18.3028 8.65375 18.3489 8.49379 18.3473 8.33075C18.3456 8.16771 18.2961 8.00874 18.2049 7.87354C18.1138 7.73834 17.985 7.63285 17.8345 7.57013L10.692 4.3168C10.4749 4.21776 10.239 4.1665 10.0003 4.1665C9.76166 4.1665 9.52579 4.21776 9.30865 4.3168L2.16699 7.5668C2.01863 7.63178 1.89242 7.73858 1.80379 7.87415C1.71517 8.00971 1.66797 8.16817 1.66797 8.33014C1.66797 8.4921 1.71517 8.65055 1.80379 8.78612C1.89242 8.92169 2.01863 9.02849 2.16699 9.09347L9.30865 12.3501C9.52579 12.4492 9.76166 12.5004 10.0003 12.5004C10.239 12.5004 10.4749 12.4492 10.692 12.3501L17.8503 9.1018Z",
    stroke: "#9333EA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 8.33325V13.3333",
    stroke: "#9333EA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.4167V13.3334C5 13.9965 5.52678 14.6323 6.46447 15.1012C7.40215 15.57 8.67392 15.8334 10 15.8334C11.3261 15.8334 12.5979 15.57 13.5355 15.1012C14.4732 14.6323 15 13.9965 15 13.3334V10.4167",
    stroke: "#9333EA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.0c58e0d29b2700de9387fdcd6b77a446.svg";
export { ForwardRef as ReactComponent };